<template>
  <!--角色管理 -->
  <div>
    <div>
      <el-card style="margin: 30px">
        <div style="display: flex;align-items: center">
          <div>角色名称：</div>
          <el-input placeholder="请输入搜索内容..." size="small" style="width: 200px;margin-right: 10px" v-model="keyword"
                    clearable @clear="searchBtn"></el-input>
          <el-button @click="searchBtn" type="primary" size="small">查询</el-button>
          <el-button size="small" type="danger" @click="resetBtn">重置</el-button>
          <el-button v-if="btnList.includes('role_add')" @click="addBtn" type="success" size="small">新增</el-button>
        </div>
        <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%;margin-top: 30px"
        >
          <el-table-column label="角色名称" prop="role_name" align="center" width="450"></el-table-column>
          <el-table-column label="角色编码" prop="role_code" align="center" width="450"></el-table-column>
          <el-table-column
              align="center"
              label="操作"
          >
            <template slot-scope="scope">
              <el-button v-if="btnList.includes('role_edit')" @click="editBtn(scope.row)" type="success" size="mini">
                修改
              </el-button>
              <el-button v-if="btnList.includes('role_freeze')" @click="freezeBtn(scope.row)"
                         :type="scope.row.delete_status === 1?'danger':'warning'"
                         size="mini">{{ scope.row.delete_status === 1 ? '禁用' : '启用' }}
              </el-button>
              <el-button v-if="btnList.includes('role_edit_permission')" @click="editPermissionBtn(scope.row)"
                         type="success" size="mini">编辑权限
              </el-button>
              <el-button v-if="btnList.includes('role_view_permission')" @click="viewPermissionBtn(scope.row)"
                         type="primary" size="mini">查看权限
              </el-button>
              <el-button v-if="btnList.includes('role_edit_page')" @click="editPageBtn(scope.row)" type="success"
                         size="mini">编辑页面
              </el-button>
              <el-button v-if="btnList.includes('role_view_page')" @click="viewPageBtn(scope.row)" type="primary"
                         size="mini">查看页面
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="display: flex;justify-content: center;margin-top: 20px"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalElements">
        </el-pagination>
      </el-card>
    </div>
    <!-- 新增角色的弹窗 -->
    <a-modal
        :title="addDialogTitle"
        :visible="addDialogState"
        ok-text="确认"
        cancel-text="取消"
        width="400px"
        @ok="userAddSubmit('ruleForm')"
        @cancel="userAddCancel"
    >
      <el-form
          class="small-space"
          :model="ruleForm"
          :rules="rules"
          label-position="right"
          label-width="110px"
          ref="ruleForm"
      >
        <el-form-item label="角色名称" prop="roleName">
          <el-input type="text" placeholder="请输入角色名称" v-model="ruleForm.roleName" style="width: 200px" size="small"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="角色编码" prop="roleCode">
          <el-input type="text" placeholder="请输入角色编码" v-model="ruleForm.roleCode" style="width: 200px" size="small"
                    clearable></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

    <!--    角色编辑页面的弹窗-->
    <a-modal
        :title="rolePageTitle"
        :visible="rolePageDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="rolePageCancel"
        @ok="rolePageSubmit"
    >
      <el-tree
          ref="tree"
          :data="pageData"
          :expand-on-click-node="false"
          :props="defaultProps"
          show-checkbox
          :check-strictly="false"
          default-expand-all
          highlight-current
          node-key="id"
          @check-change="checkChange">
      </el-tree>
    </a-modal>

    <!--    角色编辑权限的弹窗-->
    <a-modal
        :title="rolePermissionTitle"
        :visible="rolePermissionDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="rolePermissionCancel"
        @ok="rolePermissionSubmit"
    >
      <el-tree
          ref="permissiontree"
          :data="permissionData"
          :expand-on-click-node="false"
          :props="permissionDefaultProps"
          show-checkbox
          default-expand-all
          highlight-current
          node-key="id"
          @check-change="permissionCheckChange">
      </el-tree>
    </a-modal>

    <!--    冻结用户弹窗-->
    <a-modal
        title="提示"
        :visible="freezeDialogState"
        cancel-text="取消"
        ok-text="确认"
        width="400px"
        @cancel="freezeCancel"
        @ok="freezeSubmit"
    >
      <div>是否禁用该角色？</div>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      addDialogState: false,//新增弹窗开启关闭
      addDialogTitle: '',
      pageNum: 1,
      pageSize: 20,
      keyword: '',
      totalElements: 0,//数据总数
      ruleForm: {
        id: "",
        roleName: "",
        roleCode: ""
      },
      rules: {
        roleName: [{required: true, message: "请输入角色名称", trigger: "blur"}],
        roleCode: [{required: true, message: "请输入角色编码", trigger: "blur"}],
      },
      tableData: [], //用户列表

      //角色页面部分
      rolePageTitle: '',
      rolePageDialogState: false,
      pageData: [],
      defaultProps: {
        children: 'childMap',
        label: 'page_name'
      },
      rolePageLoadFinish: false,
      currentRoleId: '',
      //角色权限部分
      rolePermissionTitle: '',
      rolePermissionDialogState: false,
      permissionData: [],
      permissionDefaultProps: {
        children: 'childMap',
        label: 'page_name'
      },
      rolePermissionLoadFinish: false,


      freezeDialogState:false,
      freezeRow:{},

      btnList: []
    };
  },
  methods: {
    userAddCancel() {
      this.addDialogState = false;
      this.$refs.ruleForm.clearValidate();
    },
    //添加用户：
    addBtn() {
      this.ruleForm = {
        id: "",
        roleName: "",
        roleCode: "",
      }
      this.addDialogTitle = '新增角色'
      this.addDialogState = true;
    },
    //编辑用户
    editBtn(row) {
      this.ruleForm.id = row.id
      this.ruleForm.roleName = row.role_name
      this.ruleForm.roleCode = row.role_code
      this.addDialogTitle = '编辑角色'
      this.addDialogState = true
    },
    //冻结/解冻角色
    freezeBtn(row) {
      if (row.delete_status === 1){
        this.freezeRow = row
        this.freezeDialogState = true
      }else{
        this.postAxios("/sysUser/updSysRole", {
          id: row.id,
          updateType: 2,
          deleteStatus: row.delete_status === 1 ? 2 : 1
        }).then(res => {
          if (res.success) {
            this.$message.success(row.delete_status === 1 ? '禁用成功!' : '启用成功!')
            this.getRoleList()
          }
        })
      }
    },
    //编辑页面
    editPageBtn(row) {
      this.currentRoleId = row.id
      this.rolePageTitle = '编辑页面'
      this.postAxios("/sysUser/selSysPage", {}).then(res => {
        if (res.success) {
          this.rolePageLoadFinish = false
          this.pageData = res.content;
          this.rolePageDialogState = true
          setTimeout(() => {
            this.postAxios("/sysUser/selPageByRoleId", {
              parameterMap: {
                roleId: this.currentRoleId
              }
            }).then(res => {
              console.log('当前角色的页面', res)
              if (res.success) {
                if (res.content && res.content.length) {
                  let list = []
                  res.content.forEach((item) => {
                    list.push(item.sys_page_id)
                  })
                  console.log(list, 'list')
                  this.$refs.tree.setCheckedKeys(list);
                } else {
                  this.$refs.tree.setCheckedKeys([]);
                }
              }
            })
          }, 100)
          setTimeout(() => {
            this.rolePageLoadFinish = true
          }, 1000)
        } else {
          this.pageData = []
        }
      });
    },
    //查看页面
    viewPageBtn(row) {
      this.currentRoleId = row.id
      this.rolePageTitle = '查看页面'
      this.postAxios("/sysUser/selSysPage", {}).then(res => {
        if (res.success) {
          this.rolePageLoadFinish = false
          res.content.forEach((item) => {
            item.disabled = true
            if (item.childMap && item.childMap.length) {
              item.childMap.forEach((childItem) => {
                childItem.disabled = true
              })
            }
          })
          this.pageData = res.content;
          this.rolePageDialogState = true
          setTimeout(() => {
            this.postAxios("/sysUser/selPageByRoleId", {
              parameterMap: {
                roleId: this.currentRoleId
              }
            }).then(res => {
              console.log('当前角色的页面', res)
              if (res.success) {
                if (res.content && res.content.length) {
                  let list = []
                  res.content.forEach((item) => {
                    list.push(item.sys_page_id)
                  })
                  console.log(list, 'list')
                  this.$refs.tree.setCheckedKeys(list);
                } else {
                  this.$refs.tree.setCheckedKeys([]);
                }
              }
            })
          }, 100)
          setTimeout(() => {
            this.rolePageLoadFinish = true
          }, 1000)
        } else {
          this.pageData = []
        }
      });
    },
    //编辑权限
    editPermissionBtn(row) {
      this.currentRoleId = row.id
      this.rolePermissionTitle = '编辑权限'
      this.postAxios("/sysUser/AllSysPageAndAllPermission", {}).then(res => {
        if (res.success) {
          this.rolePermissionLoadFinish = false
          this.permissionData = res.content
          this.permissionData.forEach((item) => {
            item.id = item.id + 999
            item.disabled = true
            item.childMap.forEach((itemI) => {
              itemI.id = itemI.id + 99999
              // itemI.disabled = true
            })
          })
          this.rolePermissionDialogState = true
          setTimeout(() => {
            this.postAxios("/sysUser/selPermissionByRoleId", {
              parameterMap: {
                roleId: this.currentRoleId
              }
            }).then(res => {
              if (res.success) {
                if (res.content && res.content.length) {
                  let list = []
                  res.content.forEach((item) => {
                    list.push(item.permission_id)
                  })
                  console.log(list, 'list')
                  this.$refs.permissiontree.setCheckedKeys(list);
                } else {
                  this.$refs.permissiontree.setCheckedKeys([]);
                }
              }
            })
          }, 600)
          setTimeout(() => {
            this.rolePermissionLoadFinish = true
          }, 1000)
        } else {
          this.permissionData = []
        }
      })
    },
    viewPermissionBtn(row) {
      this.currentRoleId = row.id
      this.rolePermissionTitle = '查看权限'
      this.postAxios("/sysUser/AllSysPageAndAllPermission", {}).then(res => {
        if (res.success) {
          this.rolePermissionLoadFinish = false
          this.permissionData = res.content
          this.permissionData.forEach((item) => {
            item.id = item.id + 999
            item.disabled = true
            item.childMap.forEach((itemI) => {
              itemI.id = itemI.id + 9999
              itemI.disabled = true
              itemI.childMap.forEach((itemII) => {
                itemI.id = itemI.id + 99999
                itemII.disabled = true
              })
            })
          })
          this.rolePermissionDialogState = true
          setTimeout(() => {
            this.postAxios("/sysUser/selPermissionByRoleId", {
              parameterMap: {
                roleId: this.currentRoleId
              }
            }).then(res => {
              if (res.success) {
                if (res.content && res.content.length) {
                  let list = []
                  res.content.forEach((item) => {
                    list.push(item.permission_id)
                  })
                  console.log(list, 'list')
                  this.$refs.permissiontree.setCheckedKeys(list);
                } else {
                  this.$refs.permissiontree.setCheckedKeys([]);
                }
              }
            })
          }, 600)
          setTimeout(() => {
            this.rolePermissionLoadFinish = true
          }, 1000)
        } else {
          this.permissionData = []
        }
      })
    },
    searchBtn() {
      this.getRoleList()
    },
    resetBtn() {
      this.pageNum = 1
      this.pageSize = 20
      this.keyword = ''
      this.getRoleList()
    },
    // 确认添加用户：
    userAddSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.addDialogTitle === '新增角色') {
            this.postAxios("/sysUser/addSysRole", {
              roleName: this.ruleForm.roleName,
              roleCode: this.ruleForm.roleCode
            }).then(res => {
              if (res.success) {
                this.addDialogState = false
                this.$message.success('添加成功!')
                this.getRoleList();
              }
            })
          } else {
            this.postAxios("/sysUser/updSysRole", {
              id: this.ruleForm.id,
              updateType: 1,
              roleName: this.ruleForm.roleName,
              roleCode: this.ruleForm.roleCode
            }).then(res => {
              if (res.success) {
                this.addDialogState = false
                this.$message.success('修改成功!')
                this.getRoleList();
              }
            })
          }
        }
      });
    },
    //用户列表
    getRoleList() {
      this.postAxios("/sysUser/selSysRole", {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        parameterMap: {
          roleName: this.keyword
        }
      }).then(res => {
        if (res.success) {
          this.tableData = []
          this.tableData = res.content;
          this.totalElements = res.totalCount
        } else {
          this.tableData = []
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getRoleList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getRoleList()
    },
    rolePageSubmit() {
      this.rolePageDialogState = false
      this.$message.success('保存成功!')
    },
    rolePageCancel() {
      this.rolePageDialogState = false
    },
    freezeSubmit() {
      this.postAxios("/sysUser/updSysRole", {
        id: this.freezeRow.id,
        updateType: 2,
        deleteStatus: this.freezeRow.delete_status === 1 ? 2 : 1
      }).then(res => {
        if (res.success) {
          this.freezeDialogState = false
          this.$message.success(this.freezeRow.delete_status === 1 ? '禁用成功!' : '启用成功!')
          this.getRoleList()
        }
      })
    },
    freezeCancel(){
      this.freezeDialogState = false
    },
    rolePermissionSubmit() {
      this.rolePermissionDialogState = false
      this.$message.success('保存成功!')
    },
    rolePermissionCancel() {
      this.rolePermissionDialogState = false
    },
    permissionCheckChange(row, checkState, state) {
      console.log('--------row-------',row)
      console.log('点击当前节点', row, checkState, state)
      if (this.rolePermissionLoadFinish) {
        if (checkState) {
          if (!row.parent_id){
            let params = []
            params.push({'roleId': this.currentRoleId, 'permissionId': row.id})
            console.log('新增权限传参', params)
            if(!row.page_code){
              this.postAxios("/sysUser/addPermissionForRole", params)
            }
          }
        } else {
          if (!state) {
            if (!row.parent_id){
              let params = {
                parameterMap: {
                  roleId: this.currentRoleId,
                  permissionIdList: []
                }
              }
              params.parameterMap.permissionIdList.push(row.id)
              console.log('删除权限id', params)
              if(!row.page_code){
                this.postAxios("/sysUser/delPermissionById", params)
              }
            }
          }
        }
      }
    },
    checkChange(row, checkState, state) {
      if (this.rolePageLoadFinish) {
        console.log('点击当前节点', row, checkState, state)
        if (checkState) {
          if (row.parent_id !== 0){
            let params = []
            params.push({'roleId': this.currentRoleId, 'pageId': row.id})
            console.log('新增页面的参数', params)
            this.postAxios("/sysUser/addPageForRole", params)
          }
        } else {
          if (!state) {
            let params = {
              parameterMap: {
                roleId: this.currentRoleId,
                pageIdList: []
              }
            }
            params.parameterMap.pageIdList.push(row.id)
            this.postAxios("/sysUser/delPageById", params)
          }
        }
      }
    },
  },
  created() {
    this.getRoleList(); //用户的列表
    //获取用户当前页面的按钮权限
    if (this.$store.state.buttonPermission && this.$store.state.buttonPermission.length) {
      this.btnList = []
      this.$store.state.buttonPermission.forEach((item) => {
        if (item.page_code === '/system/role') {
          this.btnList.push(item.action)
        }
      })
    }
  }
};
</script>
<style>
</style>
